// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__Kt5Ma","fz223":"Badge_fz223__kO2Qb","eshop":"Badge_eshop__K_NM8","com":"Badge_com__VSveF"};